document.addEventListener('DOMContentLoaded', function() {
    // ========================================
    // Selling Plan - KittySupps model "Subskrybuj i oszczedz 20%"
    // JEDEN plan: FIXED 119,99 zl za sztuke, interwal 30 dni, qty-based bundle.
    // ID podpiety tylko do produktu KOTA (dev). Brak selektora czestotliwosci.
    // ========================================
    const SUBSCRIPTION_PLAN_ID = ((window.PawmatePDPConfig||{}).plan1||'');
    const sellingPlanInput = document.getElementById('selling-plan-input');

    // Ustaw / wyczysc selling plan (jedyna droga planu do koszyka).
    // pusty string = one-time, SUBSCRIPTION_PLAN_ID = subskrypcja 20% off.
    function setSellingPlan(isSubscription) {
      if (!sellingPlanInput) return;
      var ac = (typeof getActiveCard === "function") ? getActiveCard() : null;
      var planId = (ac && ac.dataset.subPlan) ? ac.dataset.subPlan : SUBSCRIPTION_PLAN_ID;
      sellingPlanInput.value = isSubscription ? planId : '';
    }

    // Quantity selector
    const quantityWrapper = document.querySelector('.product-main__quantity');
    if (quantityWrapper) {
      const minusBtn = quantityWrapper.querySelector('.product-main__quantity-btn--minus');
      const plusBtn = quantityWrapper.querySelector('.product-main__quantity-btn--plus');
      const input = quantityWrapper.querySelector('.product-main__quantity-input');

      minusBtn.addEventListener('click', function() {
        const currentValue = parseInt(input.value) || 1;
        if (currentValue > 1) {
          input.value = currentValue - 1;
        }
      });

      plusBtn.addEventListener('click', function() {
        const currentValue = parseInt(input.value) || 1;
        if (currentValue < 99) {
          input.value = currentValue + 1;
        }
      });
    }

    // ========================================
    // Product Gallery - Simple & Robust
    // ========================================
    (function() {
      var gallery = document.querySelector('.product-gallery-desktop');
      var mainImg = document.getElementById('product-main-image');
      if (!gallery || !mainImg) return;

      var thumbs = gallery.querySelectorAll('.product-main__thumb');
      var currentIdx = 0;

      // Find initial active
      thumbs.forEach(function(t, i) {
        if (t.classList.contains('product-main__thumb--active')) currentIdx = i;
      });

      function setImage(idx) {
        if (idx < 0 || idx >= thumbs.length) return;
        var thumb = thumbs[idx];
        var url = thumb.getAttribute('data-image-url');
        var alt = thumb.getAttribute('data-image-alt') || '';
        if (!url) return;

        // Fade out
        mainImg.style.opacity = '0';

        setTimeout(function() {
          // IMPORTANT: Clear srcset to force browser to use src
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = url;
          mainImg.alt = alt;

          // Update active states
          thumbs.forEach(function(t) {
            t.classList.remove('product-main__thumb--active');
            t.setAttribute('aria-selected', 'false');
          });
          thumb.classList.add('product-main__thumb--active');
          thumb.setAttribute('aria-selected', 'true');

          // Fade in (on load or immediate if cached)
          if (mainImg.complete) {
            mainImg.style.opacity = '1';
          } else {
            mainImg.onload = function() { mainImg.style.opacity = '1'; };
          }
          currentIdx = idx;
        }, 120);
      }

      // Thumbnail clicks (desktop only - mobile handled separately)
      thumbs.forEach(function(thumb, idx) {
        thumb.addEventListener('click', function(e) {
          e.preventDefault();
          if (window.innerWidth > 768 && idx !== currentIdx) setImage(idx);
        });
      });

      // Arrow clicks
      var prevBtn = gallery.querySelector('.product-main__nav-arrow--prev');
      var nextBtn = gallery.querySelector('.product-main__nav-arrow--next');

      if (prevBtn) {
        prevBtn.addEventListener('click', function(e) {
          e.preventDefault();
          var newIdx = currentIdx > 0 ? currentIdx - 1 : thumbs.length - 1;
          setImage(newIdx);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          var newIdx = currentIdx < thumbs.length - 1 ? currentIdx + 1 : 0;
          setImage(newIdx);
        });
      }

      // Keyboard navigation
      document.addEventListener('keydown', function(e) {
        if (e.target.matches('input, textarea, select')) return;
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          var newIdx = currentIdx > 0 ? currentIdx - 1 : thumbs.length - 1;
          setImage(newIdx);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          var newIdx = currentIdx < thumbs.length - 1 ? currentIdx + 1 : 0;
          setImage(newIdx);
        }
      });
    })();

    // Mobile gallery swipe with indicator dots
    const galleryTrack = document.getElementById('gallery-track');
    const galleryDots = document.querySelectorAll('.product-gallery-mobile__dot');

    // Block Safari back/forward gesture on gallery edges
    if (galleryTrack) {
      galleryTrack.addEventListener('touchstart', function(e) {
        var touch = e.touches[0];
        if (touch.pageX < 25 || touch.pageX > window.innerWidth - 25) {
          e.preventDefault();
        }
      }, { passive: false });
    }

    if (galleryTrack && galleryDots.length > 0) {
      // Update active dot based on scroll position
      function updateActiveDot() {
        const scrollLeft = galleryTrack.scrollLeft;
        const slideWidth = galleryTrack.offsetWidth;
        const activeIndex = Math.round(scrollLeft / slideWidth);

        galleryDots.forEach(function(dot, index) {
          if (index === activeIndex) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      }

      // Scroll to specific slide when dot is clicked
      galleryDots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          const index = parseInt(dot.dataset.index);
          const slideWidth = galleryTrack.offsetWidth;
          galleryTrack.scrollTo({
            left: slideWidth * index,
            behavior: 'smooth'
          });
        });
      });

      // Update dots on scroll with rAF
      let dotTicking = false;
      galleryTrack.addEventListener('scroll', function() {
        if (!dotTicking) {
          requestAnimationFrame(function() {
            updateActiveDot();
            dotTicking = false;
          });
          dotTicking = true;
        }
      }, {passive: true});

      // Initial update
      updateActiveDot();

      // Sync thumbnails with mobile gallery (mobile only)
      var mobileThumbSync = (function() {
        var thumbs = document.querySelectorAll('.product-main__gallery-thumbs .product-main__thumb');
        if (!thumbs.length) return;

        // When mobile gallery scrolls, update active thumbnail
        function updateActiveThumb() {
          if (window.innerWidth > 768) return;
          var scrollLeft = galleryTrack.scrollLeft;
          var slideWidth = galleryTrack.offsetWidth;
          if (slideWidth === 0) return;
          var activeIndex = Math.round(scrollLeft / slideWidth);
          thumbs.forEach(function(t, i) {
            if (i === activeIndex) {
              t.classList.add('product-main__thumb--active');
              t.setAttribute('aria-selected', 'true');
            } else {
              t.classList.remove('product-main__thumb--active');
              t.setAttribute('aria-selected', 'false');
            }
          });
        }

        // When thumb is clicked, scroll mobile gallery to that slide and update active state
        thumbs.forEach(function(thumb, idx) {
          thumb.addEventListener('click', function() {
            if (window.innerWidth <= 768 && galleryTrack) {
              var slideWidth = galleryTrack.offsetWidth;
              galleryTrack.scrollTo({ left: slideWidth * idx, behavior: 'smooth' });
              // Immediately update active state
              thumbs.forEach(function(t, i) {
                if (i === idx) {
                  t.classList.add('product-main__thumb--active');
                  t.setAttribute('aria-selected', 'true');
                } else {
                  t.classList.remove('product-main__thumb--active');
                  t.setAttribute('aria-selected', 'false');
                }
              });
            }
          });
        });

        var thumbTicking = false;
        galleryTrack.addEventListener('scroll', function() {
          if (!thumbTicking) {
            requestAnimationFrame(function() {
              updateActiveThumb();
              thumbTicking = false;
            });
            thumbTicking = true;
          }
        }, {passive: true});

        // Initial sync
        updateActiveThumb();
      })();
    }

    // ========================================
    // KittySupps Purchase Selector Logic - "Buy More, Save More"
    // Stan: selectedQty (1/2/3), isSubscription (checkbox).
    // ========================================
    const bundleCardsWrap = document.getElementById('bundle-cards');
    const bundleCards = bundleCardsWrap ? bundleCardsWrap.querySelectorAll('.bundle-card') : [];
    const subToggleCheckbox = document.getElementById('sub-toggle-checkbox');
    const subToggle = document.getElementById('sub-toggle');
    const quantityInput = document.querySelector('.product-main__quantity-input');
    const addToCartBtn = document.querySelector('.product-main__add-to-cart');
    const dogWeightInput = document.getElementById('dog-weight-input');
    const bundleSizeInput = document.getElementById('bundle-size-input');
    const bundleLabelInput = document.getElementById('bundle-label-input');
    const displayedPriceInput = document.getElementById('displayed-price-input');
    const omnibusEl = document.getElementById('product-omnibus-price');
    const mobileTextEl = document.querySelector('.mobile-add-to-cart__text');

    function getBundleLabel(qty) {
      return qty == 1 ? '1 butelka' : qty + ' butelki';
    }

    let selectedQty = 1;
    let isSubscription = subToggleCheckbox ? subToggleCheckbox.checked : false;

    // Pobierz aktualnie aktywna karte (zawsze jedna)
    function getActiveCard() {
      let active = bundleCardsWrap ? bundleCardsWrap.querySelector('.bundle-card--active') : null;
      if (!active && bundleCards.length) active = bundleCards[0];
      return active;
    }

    // ========================================
    // Hidden inputs sync - KRYTYCZNE dla koszyka
    //  - one-time: properties BEZ name (itemy sie mergeuja)
    //  - subskrypcja: properties dostaja name (_Bundle Size, _Cena)
    //  - selling_plan: '' (one-time) / SUBSCRIPTION_PLAN_ID (sub)
    //  - quantity: niesie 1/2/3 (bundle = qty tego samego wariantu)
    // ========================================
    function syncCartInputs() {
      const card = getActiveCard();
      if (!card) return;
      const qty = parseInt(card.dataset.qty) || 1;

      // selling plan (jedyna droga planu do koszyka)
      setSellingPlan(isSubscription);

      // quantity = liczba butelek (qty-based bundle)
      if (quantityInput) quantityInput.value = qty;

      if (isSubscription) {
        // Subskrypcja -> przywroc name na property merdzowalne
        if (bundleSizeInput) {
          bundleSizeInput.setAttribute('name', 'properties[_Bundle Size]');
          bundleSizeInput.value = qty;
        }
        if (bundleLabelInput) {
          bundleLabelInput.value = getBundleLabel(qty);
        }
        if (displayedPriceInput) {
          displayedPriceInput.setAttribute('name', 'properties[_Cena]');
          displayedPriceInput.value = card.dataset.subEach || '';
        }
        // Waga psa usunieta z modelu -> property nigdy nie dostaje name
        if (dogWeightInput) {
          dogWeightInput.removeAttribute('name');
        }
      } else {
        // One-time -> usun name z properties (identyczne itemy sie mergeuja)
        if (bundleSizeInput) {
          bundleSizeInput.removeAttribute('name');
          bundleSizeInput.value = '';
        }
        if (bundleLabelInput) {
          bundleLabelInput.removeAttribute('name');
          bundleLabelInput.value = '';
        }
        if (displayedPriceInput) {
          displayedPriceInput.removeAttribute('name');
          displayedPriceInput.value = '';
        }
        if (dogWeightInput) {
          dogWeightInput.removeAttribute('name');
        }
      }
    }

    // ========================================
    // Aktualizacja cen na kartach (one-time vs subskrypcja)
    // ========================================
    function refreshCardPrices() {
      bundleCards.forEach(function(card) {
        const eachEl = card.querySelector('[data-each]');
        const totalEl = card.querySelector('[data-total]');
        const discBadge = card.querySelector('[data-disc-badge]');

        const discVal = isSubscription ? (card.dataset.subDisc || '0') : (card.dataset.onetimeDisc || '0');
        if (isSubscription) {
          if (eachEl) eachEl.textContent = card.dataset.subEach || '';
          if (totalEl) totalEl.textContent = ((window.PawmatePDPConfig&&window.PawmatePDPConfig.totalPrefix)||'Razem:') + ' ' + (card.dataset.subTotal || '');
        } else {
          if (eachEl) eachEl.textContent = card.dataset.onetimeEach || '';
          if (totalEl) totalEl.textContent = ((window.PawmatePDPConfig&&window.PawmatePDPConfig.totalPrefix)||'Razem:') + ' ' + (card.dataset.onetimeTotal || '');
        }
        if (discBadge) {
          discBadge.textContent = discVal + '% ' + ((window.PawmatePDPConfig&&window.PawmatePDPConfig.cheaperLabel)||'taniej');
          // [EU-S1] klasa --zero dynamiczna wg AKTUALNEGO % (nie zapieczonego one-time) →
          // 1-pak sub (-20%) pokazuje badge; przełączenie one-time↔sub aktualizuje widoczność.
          discBadge.classList.toggle('bundle-card__badge-discount--zero', (parseInt(discVal, 10) || 0) <= 0);
        }
      });
    }

    // ========================================
    // Omnibus - najnizsza cena z 30 dni (total wybranego pakietu)
    // ========================================
    function updateOmnibus() {
      if (!omnibusEl) return;
      const card = getActiveCard();
      if (!card) return;
      omnibusEl.textContent = card.dataset.omnibus || omnibusEl.textContent;
    }

    // ========================================
    // CTA Button - tekst + period dla subskrypcji
    // ========================================
    function updateCTAButton() {
      const card = getActiveCard();
      if (!card) return;
      const spanElement = addToCartBtn ? addToCartBtn.querySelector('span:last-child') : null;
      // Zawsze "Dodaj do koszyka" - niezaleznie od subskrypcji
      const label = ''+((window.PawmatePDPConfig||{}).atcText||'Dodaj do koszyka')+'';
      if (spanElement) spanElement.textContent = label;
      // [V3 mobile koncept] Mobilny CTA niesie total pakietu (a la "ADD TO CART - $21.99")
      if (mobileTextEl) {
        const total = isSubscription ? (card.dataset.subTotal || '') : (card.dataset.onetimeTotal || '');
        mobileTextEl.textContent = total ? (label + ' — ' + total) : label;
      }
    }

    // ========================================
    // [V3 mobile koncept] Wiersz ceny nad benefitami (cena za butelke
    // aktywnego pakietu + compare + badge % taniej). Elementy istnieja
    // tylko w markupie PDP; na desktopie ukryte przez CSS.
    // ========================================
    function updateMobilePrice() {
      const nowEl = document.getElementById('pm-mob-price-now');
      if (!nowEl) return;
      const card = getActiveCard();
      if (!card) return;
      const compareEl = document.getElementById('pm-mob-price-compare');
      const badgeEl = document.getElementById('pm-mob-price-badge');
      const each = isSubscription ? card.dataset.subEach : card.dataset.onetimeEach;
      const disc = parseInt(isSubscription ? card.dataset.subDisc : card.dataset.onetimeDisc, 10) || 0;
      if (each) nowEl.textContent = each;
      // Compare widoczny gdy ISTNIEJE i rozni sie od ceny (karta 1 psa ma realny compare przy disc=0)
      if (compareEl) {
        const cmp = card.dataset.compareEach || '';
        compareEl.textContent = cmp;
        compareEl.style.display = (cmp && cmp !== each) ? '' : 'none';
      }
      if (badgeEl) {
        badgeEl.textContent = disc + '% ' + ((window.PawmatePDPConfig&&window.PawmatePDPConfig.cheaperLabel)||'taniej');
        badgeEl.style.display = disc > 0 ? '' : 'none';
      }
    }

    // ========================================
    // Wybor karty pakietu (radio-like)
    // ========================================
    function selectCard(card) {
      if (!card) return;
      bundleCards.forEach(function(c) {
        c.classList.remove('bundle-card--active');
        c.setAttribute('aria-checked', 'false');
      });
      card.classList.add('bundle-card--active');
      card.setAttribute('aria-checked', 'true');
      selectedQty = parseInt(card.dataset.qty) || 1;

      syncCartInputs();
      updateCTAButton();
      updateOmnibus();
      updateMobilePrice();
    }

    bundleCards.forEach(function(card) {
      card.addEventListener('click', function() { selectCard(card); });
      card.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectCard(card);
        }
      });
    });

    // [2026-07-07] Sync startowy z domyslnie aktywnej karty (2 butelki) - qty/hidden inputs/CTA/Omnibus
    selectCard(getActiveCard());

    // ========================================
    // Checkbox subskrypcji - przelacza caly selektor
    // ========================================
    if (subToggleCheckbox) {
      subToggleCheckbox.addEventListener('change', function() {
        isSubscription = subToggleCheckbox.checked;
        if (subToggle) subToggle.classList.toggle('sub-toggle--active', isSubscription);
        if (bundleCardsWrap) bundleCardsWrap.classList.toggle('bundle-cards--subscription', isSubscription);

        refreshCardPrices();
        syncCartInputs();
        updateCTAButton();
        updateOmnibus();
        updateMobilePrice();
      });
    }

    // [POST_PURCHASE 2026-06-20] Deep-link z maila upsell: ?subscribe=1 auto-zaznacza subskrypcje,
    // zeby klient od razu widzial cene -20% + wybrany plan (domyslnie toggle OFF). Dispatch 'change'
    // -> handler powyzej ustawia isSubscription, ceny, selling_plan, klasy aktywne.
    try {
      if (subToggleCheckbox && new URLSearchParams(window.location.search).get('subscribe') === '1') {
        subToggleCheckbox.checked = true;
        subToggleCheckbox.dispatchEvent(new Event('change'));
      }
    } catch (e) { /* ignore — bez deep-linku strona dziala normalnie */ }

    // ========================================
    // Initialize - one-time, 1 butelka, bez planu
    // ========================================
    if (isSubscription) {
      if (subToggle) subToggle.classList.add('sub-toggle--active');
      if (bundleCardsWrap) bundleCardsWrap.classList.add('bundle-cards--subscription');
    }
    refreshCardPrices();
    syncCartInputs();
    updateCTAButton();
    updateOmnibus();

    // ========================================
    // Accordion Animation - Web Animations API
    // ========================================
    const accordions = document.querySelectorAll('.product-accordion');
    const ANIMATION_DURATION = 300;
    const ANIMATION_EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

    // Close a specific accordion (used by exclusive mode)
    function closeAccordion(acc) {
      var c = acc.querySelector('.product-accordion__content');
      if (!c || !acc.hasAttribute('open')) return;
      var h = c.scrollHeight;
      c.animate([
        { height: h + 'px', opacity: 1 },
        { height: '0px', opacity: 0 }
      ], { duration: ANIMATION_DURATION, easing: ANIMATION_EASING, fill: 'forwards' })
      .onfinish = function() {
        acc.removeAttribute('open');
        c.style.height = '0';
        c.style.opacity = '0';
      };
    }

    accordions.forEach(function(accordion) {
      const header = accordion.querySelector('.product-accordion__header');
      const content = accordion.querySelector('.product-accordion__content');
      const inner = accordion.querySelector('.product-accordion__inner');

      if (!header || !content || !inner) return;

      let isAnimating = false;

      // Set initial state for open accordions
      if (accordion.hasAttribute('open')) {
        content.style.height = 'auto';
        content.style.opacity = '1';
      }

      header.addEventListener('click', function(e) {
        e.preventDefault();

        if (isAnimating) return;
        isAnimating = true;

        const isOpen = accordion.hasAttribute('open');

        if (isOpen) {
          // CLOSING: Animate height to 0
          const startHeight = content.scrollHeight;

          content.animate([
            { height: startHeight + 'px', opacity: 1 },
            { height: '0px', opacity: 0 }
          ], {
            duration: ANIMATION_DURATION,
            easing: ANIMATION_EASING,
            fill: 'forwards'
          }).onfinish = function() {
            accordion.removeAttribute('open');
            content.style.height = '0';
            content.style.opacity = '0';
            isAnimating = false;
          };

        } else {
          // Close all other open accordions first (exclusive mode on mobile)
          if (window.innerWidth <= 768) {
            accordions.forEach(function(other) {
              if (other !== accordion && other.hasAttribute('open') && !other.classList.contains('product-accordion--static')) {
                closeAccordion(other);
              }
            });
          }

          // OPENING: First set open to get true height
          accordion.setAttribute('open', '');
          const targetHeight = inner.scrollHeight;

          content.style.height = '0';
          content.style.opacity = '0';

          content.animate([
            { height: '0px', opacity: 0 },
            { height: targetHeight + 'px', opacity: 1 }
          ], {
            duration: ANIMATION_DURATION,
            easing: ANIMATION_EASING,
            fill: 'forwards'
          }).onfinish = function() {
            content.style.height = 'auto';
            content.style.opacity = '1';
            isAnimating = false;
          };
        }
      });
    });
  });

  // Add-to-cart loading state (both desktop + mobile)
  document.addEventListener('DOMContentLoaded', function() {
    var mobileBtn = document.getElementById('mobile-add-to-cart');
    var desktopBtn = document.querySelector('.product-main__add-to-cart');
    var form = document.querySelector('.product-main__form');

    function showLoading() {
      if (mobileBtn && !mobileBtn.disabled) mobileBtn.classList.add('is-loading');
      if (desktopBtn && !desktopBtn.disabled) desktopBtn.classList.add('is-loading');
    }

    function hideLoading() {
      if (mobileBtn) mobileBtn.classList.remove('is-loading');
      if (desktopBtn) desktopBtn.classList.remove('is-loading');
    }

    // Show spinner on form submit (fires for both desktop + mobile buttons)
    if (form) {
      form.addEventListener('submit', function() {
        showLoading();
      });
    }

    // Hide spinner when cart drawer confirms item added
    document.addEventListener('cart:added', function() {
      hideLoading();
    });

    // Fallback: hide after 5s if cart:added never fires
    if (form) {
      form.addEventListener('submit', function() {
        setTimeout(hideLoading, 5000);
      });
    }
  });

// ========================================
// [V3 mobile koncept] Strzalki nawigacji na zdjeciu galerii.
// Prawa przewija dalej, lewa pojawia sie gdy jest zdjecie z tylu,
// prawa znika na ostatnim slajdzie. Pasek miniatur na mobile ukryty.
// ========================================
document.addEventListener('DOMContentLoaded', function() {
  var track = document.getElementById('gallery-track');
  var prev = document.getElementById('pm-gal-prev');
  var next = document.getElementById('pm-gal-next');
  if (!track || !prev || !next) return;
  var slides = track.querySelectorAll('.product-gallery-mobile__slide');
  if (slides.length < 2) { prev.classList.add('is-hidden'); next.classList.add('is-hidden'); return; }

  function currentIndex() {
    return Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
  }
  function updateArrows() {
    var i = currentIndex();
    prev.classList.toggle('is-hidden', i <= 0);
    next.classList.toggle('is-hidden', i >= slides.length - 1);
  }
  prev.addEventListener('click', function() {
    track.scrollTo({ left: (currentIndex() - 1) * track.clientWidth, behavior: 'smooth' });
  });
  next.addEventListener('click', function() {
    track.scrollTo({ left: (currentIndex() + 1) * track.clientWidth, behavior: 'smooth' });
  });
  track.addEventListener('scroll', function() { requestAnimationFrame(updateArrows); }, { passive: true });
  window.addEventListener('resize', updateArrows);
  updateArrows();
});

/* cdn-refresh 2026-07-27 eu-launch */
